import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import { asyncStoreItemAdapter } from '@lib/store';
import * as actions from './encrypt-yamato-baggage-result.actions';
import { EncryptYamatoBaggageResultState } from './encrypt-yamato-baggage-result.state';

/**
 * encryptYamatoBaggageResult initial state
 */
export const encryptYamatoBaggageResultInitialState: EncryptYamatoBaggageResultState = {
  model: null,
  requestIds: [],
};

/**
 * List of basic actions for EncryptYamatoBaggageResult Store
 */
export const encryptYamatoBaggageResultReducerFeatures: ReducerTypes<
  EncryptYamatoBaggageResultState,
  ActionCreator[]
>[] = [
  on(actions.setEncryptYamatoBaggageResult, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest(
      { ...asyncStoreItemAdapter.extractAsyncStoreItem(state), ...payload },
      payload.requestId
    )
  ),

  on(actions.updateEncryptYamatoBaggageResult, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest({ ...state, ...payload }, payload.requestId)
  ),

  on(actions.resetEncryptYamatoBaggageResult, () => encryptYamatoBaggageResultInitialState),

  on(actions.cancelEncryptYamatoBaggageResultRequest, (state, action) =>
    asyncStoreItemAdapter.resolveRequest(state, action.requestId)
  ),

  on(actions.failEncryptYamatoBaggageResult, (state, payload) =>
    asyncStoreItemAdapter.failRequest(state, payload.requestId)
  ),

  on(actions.setEncryptYamatoBaggageResultFromApi, actions.updateEncryptYamatoBaggageResultFromApi, (state, payload) =>
    asyncStoreItemAdapter.addRequest(state, payload.requestId)
  ),
];

/**
 * EncryptYamatoBaggageResult Store reducer
 */
export const encryptYamatoBaggageResultReducer = createReducer(
  encryptYamatoBaggageResultInitialState,
  ...encryptYamatoBaggageResultReducerFeatures
);
